import { BlockQuotes, Footer, P } from "../../../../AbstractElements";

export const StaticBlockQuots = () => {
  return (
    <figure className="d-block dark-blockquote">
      <BlockQuotes className="light-card mb-2">
        <P className="mb-0 txt-primary">The only impossible journey is the one you never begin.</P>
        <Footer className="blockquote-footer pt-3">Tony Robbins</Footer>
      </BlockQuotes>
    </figure>
  );
};
